// ** React Imports
import { useEffect, useState } from "react";

// ** Third Party Components
import { addSeconds, format } from "date-fns";

// #####################################################

function formatTime(seconds) {
	const date = new Date(0);
	const updatedDate = addSeconds(date, seconds);
	return format(updatedDate, "mm:ss");
}

// #####################################################

export const useBlockResendEmail = ({ initialTime }) => {
	const [isResendDisabledByTime, setResendDisabledByTime] = useState(true);
	const [remainingTimeString, setRemainingTimeString] = useState("");
	const [remainingTimeNumber, setRemainingTimeNumber] = useState(0);

	const resendBlockTimeConst = 60;

	useEffect(() => {
		const targetTime = initialTime + resendBlockTimeConst * 1000;

		setResendDisabledByTime(true);

		const timer = setInterval(() => {
			const currentTime = new Date().getTime();
			const remainingTime = Math.max(
				Math.floor((targetTime - currentTime) / 1000),
				0
			);
			setRemainingTimeNumber(remainingTime);

			setRemainingTimeString(formatTime(remainingTime));

			if (remainingTime <= 0) {
				setResendDisabledByTime(false);
				clearInterval(timer);
			}
		}, 1000);

		return () => clearInterval(timer);
	}, [initialTime]);

	const setBlockResend = (block = true) => {
		setResendDisabledByTime(block);
	};

	return {
		isResendDisabledByTime,
		remainingTimeString,
		remainingTimeNumber,
		setBlockResend,
	};
};
